import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from 'vue';
import {
  NavBar,
  ButtonIconContextual,
  MFATemplate,
  ButtonContainer,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { useRouter } from 'vue-router/composables';
import { EMethods } from '@/modules/authentication/views/SecurityView/components/MultiFactorAuthentication/types';
import {
  IMFAInfo,
  IMFALoginResponse,
  loginMFA,
  requestLoginOTPToken
} from '@/modules/authentication/services/mfa';
import { SelectMFAMethodModal } from '@/modules/authentication/views/SecurityView/components/MFALogin/components/SelectMFAMethodModal';
import * as trackEvents from './track-events';
import {
  SEND_TOKEN_ERROR,
  WRONG_CODE_ERROR
} from '@/modules/authentication/views/SecurityView/components/MultiFactorAuthentication/helpers/text-constants/text-constants';
import { notify } from '@/modules/common/helpers/notification';
import { EMfaState } from './types';

interface Props {
  infoMfa: IMFAInfo;
  onMfaLoginSuccess?: (data: IMFALoginResponse) => void;
}

interface Emits {
  (event: 'next-step'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiFactorLogin',
  props: {
    infoMfa: null,
    onMfaLoginSuccess: { type: Function, default: () => ({}) }
  },
  emits: ["next-step"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'next-step'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { infoMfa: IMFAInfo, onMfaLoginSuccess: (data: IMFALoginResponse) => void };




const router = useRouter();
const currentMethod = ref<EMethods>(EMethods.PUSH);
const mfaState = ref<EMfaState>(EMfaState.Initial);
const hasError = ref<boolean>(false);
const isModalOpen = ref<boolean>(false);
const clearMfaInput = ref<boolean>(false);
const mfaTimer = 60;
const seconds = ref<number>(0);
let timer: NodeJS.Timeout;

const succesText = computed(() => {
  const methodText =
    currentMethod.value === EMethods.SMS ? 'via SMS' : 'pelo aplicativo';
  return `Código enviado ${methodText}`;
});
const disableButton = computed(() => mfaState.value === EMfaState.WaitingToken);
const labelButton = computed(
  () =>
    ({
      [EMfaState.Initial]: 'Tentar de outro jeito',
      [EMfaState.ResendToken]: 'Tentar de outro jeito',
      [EMfaState.WaitingToken]: `Tentar de outro jeito ${seconds.value}s`
    }[mfaState.value])
);

function openModal() {
  isModalOpen.value = true;
}

function goToPreviousView() {
  router.back();
}

function focusFirstInputPin() {
  const input = document.querySelector('input');
  input?.focus();
}

function goToDisconnectDevices() {
  emits('next-step');
}

function notification(text: string, type: NotificationTypes) {
  notify({
    group: 'wrn-notifications',
    text,
    duration: 10000,
    type
  });
}

async function handleLoginMFA(token: string) {
  trackEvents.trackFillToken();
  try {
    const response: IMFALoginResponse = await loginMFA({
      mfaSessionToken: props.infoMfa.mfaSessionToken,
      mfaToken: token
    });
    hasError.value = false;
    props.onMfaLoginSuccess(response);
  } catch (err: any) {
    if (err.code === 'mfa_session_not_found') {
      clearMfaInput.value = true;
    }
    hasError.value = true;
    notification(WRONG_CODE_ERROR, NotificationTypes.error);
  }
}

async function sendOTPToken({ showNotification = true, timer = true } = {}) {
  focusFirstInputPin();
  try {
    await requestLoginOTPToken({
      mfaSessionToken: props.infoMfa.mfaSessionToken,
      method: currentMethod.value
    });
    if (showNotification)
      notification(succesText.value, NotificationTypes.success);
    if (timer) {
      startTimer();
      mfaState.value = EMfaState.WaitingToken;
    }
  } catch {
    notification(SEND_TOKEN_ERROR, NotificationTypes.error);
  }
}

function handleSendToken(method: EMethods) {
  method === EMethods.SMS
    ? trackEvents.trackSendBySMSClick()
    : trackEvents.trackSendByPushClick();
  currentMethod.value = method;
  sendOTPToken({ showNotification: true, timer: true });
}

function clearTimer() {
  clearInterval(timer);
  seconds.value = mfaTimer;
}

function startTimer() {
  clearTimer();
  timer = setInterval(() => {
    seconds.value--;
  }, 1000);
}

watch(seconds, () => {
  if (seconds.value === 0) {
    clearTimer();
    mfaState.value = EMfaState.ResendToken;
  }
});
onMounted(() => sendOTPToken({ showNotification: false, timer: false }));

return { __sfc: true,props, emits, router, currentMethod, mfaState, hasError, isModalOpen, clearMfaInput, mfaTimer, seconds, timer, succesText, disableButton, labelButton, openModal, goToPreviousView, focusFirstInputPin, goToDisconnectDevices, notification, handleLoginMFA, sendOTPToken, handleSendToken, clearTimer, startTimer, NavBar, ButtonIconContextual, MFATemplate, ButtonContainer, ButtonSecondary, SelectMFAMethodModal }
}

})